import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as moment from 'moment';
import { noop } from '../../common';
import { DeprecatedInput, Icon } from '../../primitives';
import { buttonDd } from '../../icons';
import { ClickOutside } from '../../common/click-outside.comp';
export var TimeInputKey = 'time-input';
var TimeInput = /** @class */ (function (_super) {
    __extends(TimeInput, _super);
    function TimeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            stagedInput: '',
            timeOptionsVisible: false,
            isPm: false,
            isFocused: false
        };
        _this.timeInputWrapper = null;
        _this.timeOptions = [
            { value: 1, label: '01:00' },
            { value: 2, label: '02:00' },
            { value: 3, label: '03:00' },
            { value: 4, label: '04:00' },
            { value: 5, label: '05:00' },
            { value: 6, label: '06:00' },
            { value: 7, label: '07:00' },
            { value: 8, label: '08:00' },
            { value: 9, label: '09:00' },
            { value: 10, label: '10:00' },
            { value: 11, label: '11:00' },
            { value: 12, label: '12:00' }
        ];
        _this.handleTimeInputChange = function (value) {
            _this.setState({ stagedInput: value });
        };
        _this.handleTimeSelect = function (selectedOption) {
            _this.setState({ stagedInput: selectedOption.label }, function () {
                _this.setTimeOptionsVisible(false);
                _this.handleTimeChange();
            });
        };
        _this.handleAmPmToggle = function () {
            _this.props.disabled ? noop() :
                _this.setState({ isPm: !_this.state.isPm }, _this.handleTimeInputBlur);
        };
        _this.forceSelectBlur = function () {
            if (_this.timeInputWrapper) {
                var input = _this.timeInputWrapper.querySelector('input');
                if (input) {
                    input.blur();
                }
            }
        };
        _this.handleTimeInputFocus = function () {
            _this.setState({ isFocused: true });
        };
        _this.handleTimeChange = function () {
            var stagedInput = _this.state.stagedInput;
            var time = moment(stagedInput, 'HH:mm');
            var isTimeValid = time.isValid();
            var rawHours = time.hours();
            var isPm = _this.state.isPm;
            var hours = isPm ? (rawHours < 12 ? (rawHours + 12) % 24 : rawHours) : rawHours === 12 ? 0 : rawHours;
            var minutes = time.minutes();
            var maybeUpdatedValue = isTimeValid ? { hours: hours, minutes: minutes } : _this.props.value;
            var updatedStagedValue = _this.timeInputValueToString(maybeUpdatedValue);
            _this.setState({ stagedInput: updatedStagedValue, isFocused: false });
            _this.props.onChange(maybeUpdatedValue);
        };
        _this.handleTimeInputBlur = function () {
            _this.handleTimeChange();
            _this.setState({ isFocused: false }, function () { return _this.setTimeOptionsVisible(false); });
        };
        // Return 12-hour string representation of the value
        _this.timeInputValueToString = function (value) {
            var hours = value.hours, minutes = value.minutes;
            return moment({ hours: hours, minutes: minutes }).format('hh:mm');
        };
        _this.setTimeInputWrapperElement = function (e) {
            _this.timeInputWrapper = e;
        };
        _this.toggleTimeOptions = function () { return _this.props.disabled ? noop() : _this.setTimeOptionsVisible(!_this.state.timeOptionsVisible); };
        _this.closeTimeOptions = function () { return _this.setTimeOptionsVisible(false); };
        _this.setTimeOptionsVisible = function (val) {
            if (_this.props.onOpenOptions) {
                _this.props.onOpenOptions(val);
            }
            _this.setState({ timeOptionsVisible: val });
        };
        _this.renderOption = function (option) {
            var handleTimeSelect = function () { return _this.handleTimeSelect(option); };
            var isSelected = option.label === _this.state.stagedInput;
            var cn = namespacedClassnames('time-option', { selected: isSelected });
            // tslint:disable-next-line:max-line-length
            return React.createElement("div", { key: option.value, onClick: handleTimeSelect, className: cn, "data-value": option.value }, option.label);
        };
        _this.renderTimeOptionsMenu = function (ddOpen) {
            var toggleClassName = namespacedClassnames('toggle-options-button', {
                disabled: _this.props.disabled,
            });
            if (ddOpen) {
                return (React.createElement(ClickOutside, { onOuterClick: _this.closeTimeOptions },
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: 'time-options-menu' }, _this.timeOptions.map(function (o) { return _this.renderOption(o); })),
                        React.createElement("div", { className: toggleClassName, onClick: _this.toggleTimeOptions },
                            React.createElement(Icon, { icon: buttonDd })))));
            }
            return (React.createElement("div", { className: toggleClassName, onClick: _this.toggleTimeOptions },
                React.createElement(Icon, { icon: buttonDd })));
        };
        _this.state.stagedInput = _this.timeInputValueToString(_this.props.value);
        _this.state.isPm = props.value.hours >= 12;
        return _this;
    }
    TimeInput.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps && nextProps.value && !this.state.isPm) {
            this.setState({ isPm: nextProps.value.hours >= 12 });
        }
        // handles business hours apply to all functionality
        if (nextProps.value.hours !== this.props.value.hours || nextProps.value.minutes !== this.props.value.minutes) {
            this.state.stagedInput = this.timeInputValueToString(nextProps.value);
            this.state.isPm = nextProps.value.hours >= 12;
        }
    };
    TimeInput.prototype.render = function () {
        var _a = this, state = _a.state, props = _a.props;
        var classNames = namespacedClassnames(TimeInputKey, props.className, {
            'is-focused': state.isFocused,
            'dd-open': state.timeOptionsVisible
        });
        var amPmClassName = namespacedClassnames('period', {
            disabled: props.disabled,
        });
        var renderedTime = state.stagedInput;
        var renderedPeriod = state.isPm ? 'pm' : 'am';
        var ddOpen = state.timeOptionsVisible;
        return (React.createElement("div", { className: classNames, ref: this.setTimeInputWrapperElement },
            React.createElement(DeprecatedInput, { value: state.stagedInput, placeholder: renderedTime, onChange: this.handleTimeInputChange, onFocus: this.handleTimeInputFocus, onBlur: this.handleTimeInputBlur, disabled: this.props.disabled }),
            this.renderTimeOptionsMenu(ddOpen),
            React.createElement("div", { className: amPmClassName, onClick: this.handleAmPmToggle }, renderedPeriod)));
    };
    return TimeInput;
}(React.Component));
export { TimeInput };
//# sourceMappingURL=time-input.js.map